/** Variance badge pill with consistent colors across ZBC + RFQ + Settlement. */
import { Pill } from "@/components/common/UI";
import { fmtPct } from "@/lib/format";

const TONE = {
    GREEN: { tone: "emerald", label: "Fair" },
    AMBER: { tone: "amber", label: "Review" },
    RED: { tone: "red", label: "Challenge" },
    FLAG: { tone: "solid_red", label: "Investigate" },
};

export function VarianceBadge({ badge, pct, showPct = true }) {
    if (!badge) return <span className="text-slate-300 text-[12px]">—</span>;
    const t = TONE[badge] || TONE.GREEN;
    return (
        <Pill tone={t.tone}>
            {showPct && pct != null ? `${pct > 0 ? "+" : ""}${fmtPct(pct)}` : t.label}
        </Pill>
    );
}

export function varianceLabel(badge) {
    return (TONE[badge] || {}).label || "—";
}

export function varianceTone(badge) {
    return (TONE[badge] || {}).tone || "slate";
}
